/**
 * Role keys matching global-api's AccessLevelKey
 * (apps/global-api/src/constants/roles.py).
 */
const Role = {
  SkyqraftEmployee: "skyqraft_employee",
  Superuser: "superuser",
  Annotator: "annotator",
  Supervisor: "supervisor",
  Owner: "owner",
  Admin: "admin",
  Customer: "customer",
  Uploader: "uploader",
  Api: "api",
  Readonly: "readonly",
  ExternalAnnotator: "external_annotator",
  GlobalAdmin: "global_admin",
  Any: "*",
} as const;

export type RoleValue = (typeof Role)[keyof typeof Role];

export default Role;
